import {Types} from "../actions/authenticationActions";
import _ from "lodash";
import {NotificationManager} from 'react-notifications';

import cleanDeep from 'clean-deep';

import {format, parseISO, addYears, subMonths, addMonths, differenceInYears, isEqual, isBefore} from "date-fns"

const calculateNextReassessmentDate = ({autoEnrolmentDutiesStartDate, lastReassessmentDate, orgCreatedAt}) => {

	const today = parseISO(format(new Date(),"yyyy-MM-dd"));
	autoEnrolmentDutiesStartDate = parseISO(autoEnrolmentDutiesStartDate);
	lastReassessmentDate = parseISO(lastReassessmentDate);
	orgCreatedAt = orgCreatedAt && parseISO(orgCreatedAt);


	// calculate the closest re-assessment date to today
	const closestReassessmentDate = addYears(autoEnrolmentDutiesStartDate, Math.ceil(differenceInYears(today, autoEnrolmentDutiesStartDate) / 3) * 3);
	console.log({closestReassessmentDate, today})

	// re-assessment has to be completed 3 months before or 3 months after the re-assessment date
	const reAssessmentWindowStart = subMonths(closestReassessmentDate, 3);
	const reAssessmentWindowEnd = addMonths(closestReassessmentDate, 3);

	const currentReassessment = format(closestReassessmentDate,"yyyy-MM-dd");
	const nextReassessment = format(addYears(closestReassessmentDate, 3),"yyyy-MM-dd");

	// if the start window is before the last re-assessment date return the next re-assessment date
	if (isBefore(reAssessmentWindowStart, lastReassessmentDate) || isEqual(reAssessmentWindowStart, lastReassessmentDate)) {
		return nextReassessment
	}

	// if the end window is before the org creation date then return the next re-assessment date
	if (orgCreatedAt && (isBefore(reAssessmentWindowEnd, orgCreatedAt) || isEqual(reAssessmentWindowEnd, orgCreatedAt))) {
		return nextReassessment
	}

	// anything else should be the current period
	return currentReassessment
}

const defaultState = { 
        showV2Reports: true,
        timesheets: {
          images: [],
          imagePreview: {},
          processing: false
        },
        timesheetImport: {
          isModalOpen: false,
          employees: {},
          // TODO get conditions 
          warningConditions: [
            {
              id: 'NF',
              name: "Employee Reference Not Found.",
            },
            {
              id: 'Leave',
              name: "Employee has Leave on this day.",
            },
            {
              id: 1,
              name: "Hours worked under 3 hours.",
              v1: ':hours',
              operand: "<",
              v2: "3"
            },
            {
              id: 2,
              name: "Hours worked more than 10 Hours",
              v1: ':totalHoursInDay',
              operand: ">",
              v2: 10
              // v2: ":scheduled-duration"
            },
            {
              id: 3,
              name: "Maximum Break time exceeded",
              v1: ':breakDuration',
              operand: ">",
              v2: "1"
            },
            {
              id: 4,
              name: "Time-In Adjusted",
              v1: ':time-in-status',
              operand: "includes",
              v2: [5, 9]
            },
            {
              id: 5,
              name: "Time-Out Adjusted",
              v1: ':time-out-status',
              operand: "includes",
              v2: [5, 9]
            },
            {
              id: 6,
              name: "Manually Entered",
              v1: ':time-in-status',
              operand: "==",
              v2: "M"
            },
            {
              id: 7,
              name: "Corrections -ve hours",
              v1: ':time-in-status',
              operand: "==",
              v2: "S"
            }
          ]
        },
        cola: {},
        employee: {
          employeeDetails: {},
          taxSettings: [],
          selectedTax: null
        },
        employees: {
          importModal: false
        },
        leave: {
          days: [0, 1, 2, 3, 4, 5, 6]
        },
        pensions: {
          scheme: {},
          group: {}
        },
        workLocation: {},
        leaveAdjustments: {
          adjustments: []
        },
        grades: {},
        groups: [],
        allowances: {},
        overtimes: {},
        departments: {},
        costCenter: {},
        asset: {},
        deputy: {
          connected: false
        },
        integration: {
          accounting: {},
          timeAttendance: {},
          payments: {
          }
        },
        payment: {
          stripe: {},
          credits: [],
        },
        payslipImport: {
          results: {}
        },
        leaveImport: {
          results: {}
        },
        leaveAdjustmentImport: {
          results: {}
        },
        payroll: {
          reopenPayrollModalOpen: false,
          payrollPage: "main",
          generatingReports: false,
          departmentExpanded: {},
          payPeriodDetails: {},
          generating: {
            all: false
          },
        },
        payrollHistory: {
          isModalOpen: false,
        },
        organisation: {},
        video: {},
        scheme: {},
        group: {},
        createAccount: {
          userCreated: false,
          userUpdated: false,
          acLeadCreated: false,
          demoAccountCreated: false,
          data: {
            organisation: "",
            vatNo: "",
            door: "",
            street: "",
            city: "",
            postcode: "",
          }
        },
        payslipHistory: {},
        payPeriods: {},
        paySchedules: {
          payScheduleList: []
        },
        sidebar: {
          show: true
        },
        company: {
          isCompanyModalOpen: false,
          isNewCompanyModalOpen: false,
          settings: {
            allowances: [],
            overtimes: [],
            paySchedules: [],
            departments: []
          },
          newCompany: {},
        },
        isNewEmployeeModalOpen: false,
        shifts: {
          current: {
            shifts: {}
          }
        },
        report: {},
        newEmployee: {},
        admin: {}
      }

const authenticationReducers = (state = defaultState, action) => {
  switch (action.type) {
    
    case Types.AUTHENTICATION_SWITCH_COMPANY: {

      let newState = {
        ..._.cloneDeep(state),
        ...defaultState,
        switchingCompany: action.loading
      };

      return newState;
    }
    case Types.AUTHENTICATION_LOGIN: {

      let newState = _.cloneDeep(state);

      if (action.payload.result && action.payload.result.session){
        newState.authentication.invalidLoginCredentials = false;
      } else if(action.attempt){
        // invalid error
        newState.authentication.invalidLoginCredentials = true;
      }

      if (action.payload.profile){ 
        const profile = action.payload.profile
        newState.my.profile = profile


        if (profile.givenName && profile.familyName && profile.email){
          window?.zE?.identify?.({
            name: `${profile.givenName} ${profile.familyName}`,
            email: profile.email,
            // organization: 
            // [360011072412]:
          });
        }
      }

      if (action.payload.permissions) {
        newState.advisors = {
          ...newState.advisors,
          permissions: action.payload.permissions,
          list: action.payload.advisorList,
        }
      }

      if (action.payload.error) {
        newState.my.profile = undefined
        newState.authentication.invalidLoginCredentials = false;
      }

      newState.authentication.lockedUntil = action.payload.lockedUntil ? action.payload.lockedUntil : false;

      if (action.payload.lockedUntil) {
        newState.authentication.invalidLoginCredentials = false; // override this so we don't display the error message
      }

      newState.authentication.processing = false;

      return newState;
    }
    case Types.AUTHENTICATION_LOGOUT: {

      let newState = _.cloneDeep(state);
/*
        console.log('sesttingCookie',action.payload)

      if (action.payload.result.session){
        var myDate = new Date();
        myDate.setMonth(myDate.getMonth() + 1);
        document.cookie = "PHPSESSID=" + action.payload.result.session + ";expires=" + myDate 
                          + ";domain=.buddy.hr;path=/";

        console.log('sesttingCookie')
      }*/

      newState.my.profile = false;

      newState.authentication.invalidLoginCredentials = false;
      newState.authentication.error = false;
      newState.authentication.processing = false;
      delete newState.organisations;
      return newState;
    }
    case Types.AUTHENTICATION_PROCESSING: {

      let newState = _.cloneDeep(state);

      newState.authentication.processing = action.saving;

      return newState;
    }
    case Types.AUTHENTICATION_VALIDATE_CODE: {

      let newState = _.cloneDeep(state);

      newState.authentication.validatingCode = true;

      return newState;
    }
    case Types.AUTHENTICATION_RECOVERY_CODE_CHECK: {

      let newState = _.cloneDeep(state);

      newState.authentication.validatingCode = false;

      if (action.payload.error){
        newState.authentication.recoveryCodeError = action.payload.error;
      } else {
        newState.authentication.recoveryCodeError = false;
      }

      if (action.payload.profile){ 
        newState.my.profile = action.payload.profile
      }

      return newState;
    }
    case Types.AUTHENTICATION_SETTING_PASSWORD: {

      let newState = _.cloneDeep(state);

      newState.authentication.settingPassword = true;

      return newState;
    }
    case Types.AUTHENTICATION_SET_PASSWORD_RESULT: {

      let newState = _.cloneDeep(state);

      newState.authentication.settingPassword = false;

      if (action.payload.error){
        newState.authentication.recoveryCodeError = action.payload.error;
      } else {
        newState.authentication.recoveryCodeError = false;
      }

      if (action.payload.profile){ 
        newState.my.profile = action.payload.profile
      }

      return newState;
    }
    case Types.AUTHENTICATION_ORGANISATIONS_LIST: {
      let newState = _.cloneDeep(state);
      // todo soft reset of data upon organisation switch
      console.log("leaction", action.payload)

      action.payload.map((org) => {
        if (org.autoEnrolmentDutiesStartDate) {
          org.nextReassessmentDate = calculateNextReassessmentDate(org);
          org.nextReassessmentDateDeadline = format(addMonths(parseISO(org.nextReassessmentDate), 3), "yyyy-MM-dd");
          let autoEnrolmentStatus = "N/A";

          // if lastReassessmentDate is 6 months before the deadline than it is completed
          if (org.lastReassessmentDate) {
              const lastReassessmentDate = new Date(org.lastReassessmentDate);
              const deadline = new Date(org.nextReassessmentDateDeadline);
              const sixMonthsBefore = new Date(deadline);
              sixMonthsBefore.setMonth(deadline.getMonth() - 6);
              if (lastReassessmentDate >= sixMonthsBefore) {
                  org.autoEnrolmentStatus = `Completed on ${format(lastReassessmentDate, "dd/MM/yyyy")}`;
              }
          } else if (org.nextReassessmentDateDeadline) {
              const today = new Date();
              const deadline = new Date(org.nextReassessmentDateDeadline);
              if (deadline < today) {
                  org.autoEnrolmentStatus = "Overdue";
              } else {
                  org.autoEnrolmentStatus = "Due";
              }
          }
        }
      })

      newState.organisations = _.orderBy(action.payload,[item => item.name?.toLowerCase()],['asc']);
      newState.organisationsLoaded = true
      return newState;
    }
    case Types.AUTHENTICATION_CREATING_DEMO: {
      let newState = _.cloneDeep(state);
      newState.creatingDemo = action.status ? action.status : undefined
      return newState;
    }
    case Types.AUTHENTICATION_LOGIN_STATUS: {
      let newState = _.cloneDeep(state);
      newState.my.loginStatus = action.loginStatus;
      return newState;
    }
    case Types.AUTHENTICATION_SET_MFA: {
      let newState = _.cloneDeep(state);
      newState.my.mfa.setup = action.payload;
      return newState;
    }
    case Types.AUTHENTICATION_MFA_VERIFIED: {
      let newState = _.cloneDeep(state);
      newState.my.mfa.verified = action.status;
      newState.my.profile.hasMFA = action.status;
      return newState;
    }
    case Types.AUTHENTICATION_MFA_MODAL_STATUS: {
      let newState = _.cloneDeep(state);
      newState.my.mfa.isModalOpen = action.status;
      return newState;
    }
    case Types.AUTHENTICATION_SET_MFA_EXPIRY: {
      let newState = _.cloneDeep(state);
      newState.my.profile.mfaExpires = action.expiry;
      return newState;
    }
    default:
      return state;
  }
};

export default authenticationReducers;
